import { useState } from 'react';
import { ConfigProvider, Modal } from 'antd';
import SweetAlert from '@components/Feedback/SweetAlert/Index';
import { StyledTable } from '@styles/datatables/datatable-antd.js';
import ptBR from 'antd/es/locale/pt_BR';
import { Spinner } from '@styles/loading.js';
import { useSelector } from 'react-redux';
import { makeSelectRelatoriosByIdProcessoAndIdUnidadeGerencia } from '@store/selectors/relatoriosSelector';

// Componente usado para visualizar relatórios
const RelatorioViewerModal = ({
    visible,
    closeModal,
    idProcesso,
    idUnidadeGerencia
}) => {
    const selector = makeSelectRelatoriosByIdProcessoAndIdUnidadeGerencia(
        idProcesso,
        idUnidadeGerencia
    );
    const documentosState = useSelector(selector);
    const [loading, setLoading] = useState(false);

    const handleFileAction = (file) => {
        if (file?.urlDocumentoSharepoint) {
            try {
                window.open(file.urlDocumentoSharepoint, '_blank');
            } catch (error) {
                console.error('Erro ao abrir o documento:', error);
                SweetAlert.toastError(`Erro ao abrir o documento ${file.nomeDocumento}.`);
            }
        }
    };

    const handleClose = () => {
        closeModal();
    };

    const columns = [
        {
            title: '#',
            render: (text, record, index) => index + 1,
            width: '10%',
            key: 'index'
        },
        {
            title: 'NOME DO ARQUIVO',
            dataIndex: 'nomeDocumento',
            key: 'nomeDocumento',
            width: '30%',
            render: (text, record) => {
                const isSaved = !!record.urlDocumentoSharepoint || !!record.id;
                return (
                    <span
                        style={{
                            textDecoration: isSaved ? 'underline' : 'none',
                            cursor: isSaved ? 'pointer' : 'not-allowed',
                            fontWeight: isSaved ? 'bold' : 'normal',
                            color: isSaved ? 'inherit' : 'gray',
                            textAlign: 'start',
                            display: 'block'
                        }}
                        onClick={() => {
                            if (isSaved) handleFileAction(record);
                            else SweetAlert.toastError('Salve o relatório antes de visualizá-lo.');
                        }}
                    >
                        {text}
                    </span>
                );
            }
        },
        {
            title: 'DATA DE UPLOAD',
            dataIndex: 'dataUpload',
            key: 'dataUpload',
            width: '20%',
            render: (date) => new Date(date).toLocaleString('pt-BR')
        },
        {
            title: 'USUÁRIO',
            dataIndex: 'nomeUsuario',
            key: 'nomeUsuario',
            width: '15%'
        },
        {
            title: 'TAMANHO',
            dataIndex: 'tamanhoArquivoEmMB',
            key: 'tamanhoArquivoEmMB',
            width: '15%',
            render: (size) => `${parseFloat(size).toFixed(4)} MB`
        },
    ];

    return (
        <div>
            <Modal
                getContainer={false}
                open={visible}
                width="60%"
                onCancel={handleClose}
                footer={null}
                centered
                title={"Visualização dos Relatórios"}
            >

                <div className="text-center">
                    <p className="fs-6 mb-1">
                        *Modal apenas para visualização dos relatórios anexados pelo auditor*
                    </p>
                </div>

                <div className="mb-0 mt-3">
                    <ConfigProvider locale={ptBR}>
                        <StyledTable
                            columns={columns}
                            dataSource={documentosState}
                            rowKey={(record) => record.id || record.tempId}
                            loading={{
                                spinning: loading,
                                indicator: <Spinner />
                            }}
                            pagination={{
                                pageSize: 5,
                                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
                            }}
                            scroll={{ y: 300, x: 'max-content' }}
                            locale={{
                                emptyText: <h3 className='m-3'>Nenhum relatório disponível para exibição.</h3>
                            }}
                        />
                    </ConfigProvider>
                </div>
                
            </Modal>
        </div>
    );
};

export default RelatorioViewerModal;